<template lang="pug">
  div
    .heading--section Upcoming Events
    Loading(:isLoading="isDataLoading", type="bar")
      .pad_t--10.pad_b--20
        | Corporate action events that will be taking place:
      b-tabs.break-lg
        b-tab(title='Today')
          template(v-if="eventsToday.length")
            .pevents--list
              EventsInfo(v-for="(event, index) in eventsToday", :key="`${index}-today`" :item="event")
          template(v-else)
            .pad_t--15
              MessageBar(type="warning")
                | No corporate events happening today

        b-tab(title='Within a week')
          template(v-if="eventsThisWeek.length")
            .pevents--list
              EventsInfo(v-for="(event, index) in eventsThisWeek", :key="`${index}-week`" :item="event")
          template(v-else)
            .pad_t--15
              MessageBar(type="warning")
                | No corporate events happening within a week
                
        b-tab(title='Within a month')
          template(v-if="eventThisMonth.length")
            .pevents--list
              EventsInfo(v-for="(event, index) in eventThisMonth", :key="`${index}-month`" :item="event")
          template(v-else)
            .pad_t--15
              MessageBar(type="warning")
                | No corporate events happening within a month




</template>


<script>
import EventsInfo from './EventsInfo';
import Loading from './Loading';
import MessageBar from './MessageBar';

import requestHandlers from '../mixins/requestHandlers';

export default {
  mixins: [requestHandlers],
  components: { 
    EventsInfo, 
    Loading,
    MessageBar
  },

  data() {
    return {
      allEvents: {},
      eventsToday: [],
      eventsThisWeek: [],
      eventThisMonth: []
    }
  },

  computed: {
  },

  methods: {
    FETCH_RECORDS() {
      this.REQUEST_INIT();
      this.$axios.get('/Portfolio/ImportantDates')
      .then(response => {
        if(response.status === 200) {
          let currentData = response.data;
          this.allEvents = currentData;
          this.eventsToday = currentData.today;
          this.eventsThisWeek = currentData.inAWeek;
          this.eventThisMonth = currentData.inAMonth;
        }
      })
      .catch(error => this.HANDLE_ERROR_GENERIC(error))
      .then(response => this.REQUEST_FINALLY());
    }
  },

  created() {
    this.FETCH_RECORDS();
  },
}
  
</script>



<style lang="scss">
  .pevents--card {

  }
  .pevents--header {
    text-align: center;
    padding: 10px 0;
    font-weight: bold;
    text-transform: uppercase;
    color: $color-primary;
    border-bottom: 2px solid #ddd;
    border-top: 2px solid #ddd;
  } 
  .pevents--list {

  }
  .pevents--item {
    border-bottom: 1px solid #ddd;
    padding: 8px 0;

    @include MQ(LG) {
      padding: 20px 0;
    }

    &:first-child {
      padding-top: 15px;
    }

    &:last-child {
      border-bottom: 0;
      padding-bottom: 15px;
    }
  }
  .pevents--type {

  }
</style>